import React from "react";

import { getImage } from "gatsby-plugin-image";

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { BgImage } from "gbimage-bridge";

import { red } from "../../../../utils/colors";
import MarkdownBlock from "../../Markdown";
import SmallShapeContainer from "../../SmallShapeContainer";

const Row = styled.div`
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.right}
        ${theme.paddings.containerOuter.left}
    `}

    display: flex;
    flex-flow: row wrap;
    gap: 40px;
    justify-content: space-between;

    & + & {
        margin-top: 60px;
    }
`;

const ItemName = styled.div`
    font-size: 1.25rem;
    font-weight: 900;
    color: ${red};
`;

const Image = styled(BgImage)`
    min-height: 250px;
    background-repeat: no-repeat;

    background-size: cover;
    ${(p) => css`
        background-position: ${p.imgPositionX} ${p.imgPositionY};
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
        min-height: 300px;
    `}
`;

const Shape = styled(SmallShapeContainer)`
    ${({ theme }) => theme.breakpoints.from.small.css`
        max-width: 100%;
    `}
    ${({ theme }) => theme.breakpoints.from.medium.css`
        max-width: 45%;
    `}
    ${({ theme }) => theme.breakpoints.from.large.css`
        width: 40%;
    `}
`;

const textContainer = css`
    justify-content: unset;
    min-height: 160px;
`;

const ContentWrapper = styled.div`
    margin-left: -1em;
`;

const ProductTiles = ({ items }) => {
    const rows = [];
    let row = [];

    items.forEach((item) => {
        row.push(item);
        if (item.break === true) {
            rows.push(row);
            row = [];
        }
    });
    if (row.length > 0) {
        rows.push(row);
    }

    return rows.map((row, rowIndex) => {
        return (
            <Row key={rowIndex}>
                {row.map((item, itemIndex) => {
                    const image = getImage(item.image.src);

                    return (
                        <Shape key={itemIndex}>
                            <SmallShapeContainer.ImageContainer>
                                <Image
                                    imgPositionX={item.imgPositionX}
                                    imgPositionY={item.imgPositionY}
                                    {...{ image }}
                                />
                            </SmallShapeContainer.ImageContainer>
                            <SmallShapeContainer.TextContainer
                                css={textContainer}
                            >
                                <>
                                    <ItemName>{item.name}</ItemName>
                                    <ContentWrapper>
                                        {item.text && (
                                            <MarkdownBlock>
                                                {item.text}
                                            </MarkdownBlock>
                                        )}
                                    </ContentWrapper>
                                </>
                            </SmallShapeContainer.TextContainer>
                        </Shape>
                    );
                })}
            </Row>
        );
    });
};

export default ProductTiles;
